import { useEffect, useRef, useState } from "react";

// Missing cards are removable; permission/network failures are not missing.
export default function useReminderCardNavigation(open, remove) {
  const [notice, setNotice] = useState(null);
  const noticeRef = useRef(null);
  useEffect(() => {
    if (notice) noticeRef.current?.scrollIntoView?.({ block:"nearest", behavior:"smooth" });
  }, [notice]);
  const navigate = async reminder => {
    setNotice(null);
    try { await open(reminder); }
    catch (error) { setNotice({ reminder, missing:error.missingCard === true, message:error.message }); }
  };
  const noticeView = notice && <div ref={noticeRef} role="alert" style={{ padding:12, marginBottom:12, color:"#B42318", background:"#FFF7F7", borderRadius:8 }}>
    {notice.message}
    {notice.missing && remove && <button type="button" onClick={async () => {
      try { await remove(notice.reminder.id); setNotice(null); }
      catch (error) { setNotice({ ...notice, message:error.message }); }
    }} style={{ marginLeft:12 }}>Remover da lista</button>}
    <button type="button" onClick={() => setNotice(null)} style={{ marginLeft:12 }}>Fechar</button>
  </div>;
  return { navigate, noticeView };
}
